import HybridCart from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29";
import {
  createContext,
  consume,
  provide,
  type ICustomElement,
} from "/npm/component-register@^0.8.7/+esm";

type WalkableNode = Parameters<typeof provide>[2];

type HybridCartContextType = () => (typeof HybridCart)["data"];

const HybridCartContext = createContext(() => () => HybridCart.data);

export const provideHybridCartContext = (
  element: WalkableNode,
): HybridCartContextType => {
  return provide(HybridCartContext, {}, element);
};

export const useHybridCartContext = (context: HybridCartContextType) => {
  return context;
};

export const useHybridCart = (element: HTMLElement & ICustomElement) => {
  const context = consume(HybridCartContext, element);

  if (!context) {
    throw console.error(
      "CartContext not found! Please ensure to wrap your custom element with hybrid-cart element.",
    );
  }

  return useHybridCartContext(context);
};
